module.exports = __webpack_public_path__ + "static/media/bg01.a0510bbd.svg";